import { ResourceUser } from './types';

export const filterDeactivatedCrewMembersFromCrew = (users: ResourceUser[]) => {
  return users.map((user) => ({
    ...user,
    crewMembers: user.crewMembers.filter((m) => !m.discardedAt),
  }));
};
